export {
  formatMoneyRs as formatMoney,
  parseMoney as parseCurrencyInput,
  formatCurrencyInput,
} from "../../../utils/money";
export {
  formatDateBr,
  formatDateTimeBr,
  getTodayIso,
  getTodayBr,
  getNowDateTimeBr,
} from "../../../utils/date";

export type PaymentMethod = "pix" | "credito" | "debito" | "dinheiro" | "troca";
export type SessionStatus = "aberto" | "fechado";
export type TransactionStatus = "pendente" | "pago" | "cancelado" | "confirmado";
export type WithdrawalType = "sangria" | "suprimento";
export type BraceletStatus = "entregue" | "devolvida" | "perdida";
export type OperatorStatus = "ativo" | "inativo";

export const PAYMENT_METHODS: { value: PaymentMethod; label: string }[] = [
  { value: "pix", label: "PIX" },
  { value: "credito", label: "Crédito" },
  { value: "debito", label: "Débito" },
  { value: "dinheiro", label: "Dinheiro" },
  { value: "troca", label: "Troca / Permuta" },
];

export const CAIXA_NAV_LINKS = [
  { to: "/caixa-financeiro", label: "Painel" },
  { to: "/caixa-financeiro/abertura", label: "Abertura" },
  { to: "/caixa-financeiro/frente", label: "Frente de Caixa" },
  { to: "/caixa-financeiro/transacoes", label: "Transações" },
  { to: "/caixa-financeiro/sangria", label: "Sangria / Suprimento" },
  { to: "/caixa-financeiro/pagamentos", label: "Pagamentos" },
  { to: "/caixa-financeiro/pulseiras", label: "Pulseiras" },
  { to: "/caixa-financeiro/operadores", label: "Operadores" },
  { to: "/caixa-financeiro/comissoes", label: "Comissões" },
  { to: "/caixa-financeiro/fechamento", label: "Fechamento" },
  { to: "/caixa-financeiro/relatorios", label: "Relatórios" },
  { to: "/caixa-financeiro/auditoria", label: "Auditoria" },
];

const PAYMENT_BADGE: Record<PaymentMethod, string> = {
  pix: "badge-light-info",
  credito: "badge-light-primary",
  debito: "badge-light-primary",
  dinheiro: "badge-light-success",
  troca: "badge-light-warning",
};

const STATUS_BADGE: Record<string, string> = {
  aberto: "badge-light-success",
  fechado: "badge-light-secondary",
  pendente: "badge-light-warning",
  pago: "badge-light-success",
  cancelado: "badge-light-danger",
  confirmado: "badge-light-success",
  ativo: "badge-light-success",
  inativo: "badge-light-danger",
  entregue: "badge-light-primary",
  devolvida: "badge-light-success",
  perdida: "badge-light-danger",
  suprimento: "badge-light-success",
  sangria: "badge-light-danger",
};

export function paymentMethodLabel(method: PaymentMethod | string): string {
  return PAYMENT_METHODS.find((m) => m.value === method)?.label || String(method);
}

export function paymentBadgeClass(method: PaymentMethod | string): string {
  return PAYMENT_BADGE[method as PaymentMethod] || "badge-light-secondary";
}

export function statusBadgeClass(status: string): string {
  return STATUS_BADGE[status] || "badge-light-secondary";
}
